import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Label, ResponsiveContainer } from 'recharts';
import PublicModalWrappers from '../public/PublicModalWrappers';
import MoreInfo from './MoreInfo';

const COLORS = ['#FF856D', '#4651B5', '#323A81', '#838ACD', '#FFC7BC'];

const CampaignDonutChart = props => {

  const [modalIsOpen, closeModal] = useState(false);


  function CustomLabel({viewBox, value1, value2}){
    const {cx, cy} = viewBox;
    return (
     <text x={cx} y={cy} fill="#3d405c" className="recharts-text recharts-label" textAnchor="middle" dominantBaseline="central">
        <tspan  x={cx} y={cy} alignmentBaseline="middle" fontSize={props.title === "Age" ? "45" : "30"}>{value1}</tspan>
        <tspan  x={cx}  y={cy + 20} fontSize="14">{value2}</tspan>
     </text>
    )
  }



  return (
    <div className="CampaignDonutChart">
      <h2>{props.title}</h2>
      <div className="CampaignBarChart_more-info" onClick={()=>props.closeModal(true)}>More info</div>

      <div className="CampaignDonutChart_container">
        <ResponsiveContainer height={300} width="60%">
          <PieChart>
            <Pie
              data={props.data}
              cx="50%"
              cy="50%"
              innerRadius={105}
              outerRadius={120}
              fill="#8884d8"
              paddingAngle={0}
              dataKey="value"
            >
              <Label
                width={30}
                position="center"
                content={
                  <CustomLabel value1={props.circleTitle} value2={props.circleText} />
                }
               />
              {props.data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="CampaignDonutChart_value-area">
          {props.data.map((element, index) => (
            <div className="CampaignDonutChart_value-list">
              <div
                className="CampaignDonutChart_value-list-dot"
                style={{ color: COLORS[index % COLORS.length] }}
              >
                ∙
              </div>
              <div className="CampaignDonutChart_value-list-li">
                <div className="CampaignDonutChart_value-list-age">
                  {element.range}
                </div>
                <div className="CampaignDonutChart_value-list-percent">
                  {`${element.value * 100} %`} | 1.4x
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <PublicModalWrappers
        isOpen={modalIsOpen}
        close={() => closeModal(!modalIsOpen)}
        width="50%"
      >
        <MoreInfo
         closeModal={closeModal}
        />
      </PublicModalWrappers>
    </div>
  );
};

export default CampaignDonutChart;
